import React from "react";
import { Link } from "react-router";
import Select from "react-select";
import DatePicker from "react-datepicker";
import axios from "axios";
import classNames from "classnames";
import FormErrorHandler from "../../components/FormErrorHandler";
import ChapterProgress from "../../components/ChapterProgress";
import debounce from "debounce-promise";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { downloadFile } from "../../functions";

export default class competenceprofilesForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            dirtyForm: false,
            content_editable: null,
            errorMessage: "",
            name: "",
            code: "",
            course_name: "",
            language: "nl",
            type: null,
            repetition: 0,
            types: [],
            description: "",
            illustration: null,
            is_standard: 0,
            is_active: 0,
            employer: "",
            trainers: [],
            files: [],
            file: null,
            file_name: "",
            end_terms: [],
            min_date: null,
            max_date: null,
            allow_employer_specific: 0,
            certificate_template: "default",
            certificate_templates: [],
            certificate_types: [],
            certificate_type: "diploma",
            certification_name: "",
            certification_description: "",
            max_students_per_instructor: 0,
            showEolRelated: false,
            eolGroupUUID: null,
            eolItemUUID: null,
            eolItemDisplay: null,
            showEolInsuranceRelated: false,
            eolInsuranceGroupUUID: null,
            eolInsuranceItemUUID: null,
            eolInsuranceItemDisplay: null,
            eolFullGroupUUID: null,
            eolFullItemUUID: null,
            eolFullItemDisplay: null,
            showEolFull: false,
            eolPartialGroupUUID: null,
            eolPartialItemUUID: null,
            eolPartialItemDisplay: null,
            showEolPartial: false,
            eolCancelGroupUUID: null,
            eolCancelItemUUID: null,
            eolCancelItemDisplay: null,
            showEolCancel: false,
            eolCancelKnowledgeExamGroupUUID: null,
            eolCancelKnowledgeExamItemUUID: null,
            eolCancelKnowledgeExamItemDisplay: null,
            showEolCancelKnowledgeExam: false
        };
    }

    handleSubmitPrevious = (e) => {
        e.preventDefault();

        // Save the current data and go back to the overview
        this.setState({
            followUrl: "/competenceprofiles"
        });

        this.updateCompetenceprofile();
    };

    handleSubmit = (e) => {
        e.preventDefault();

        // Save the current data and continue to the competences
        let followUrl = "/competenceprofiles/edit/" + this.props.params.itemID + "/competences";
        this.setState({
            followUrl
        });

        this.updateCompetenceprofile();
    };

    handleFileChange = (e) => {
        this.setState({
            [e.target.name]: e.target.files[0]
        });
    };

    fileUpload = (cpID) => {
        const url = `/v1/competenceprofiles/${cpID}/`;

        const formData = new FormData();
        formData.append("illustration", this.state.file, this.state.file.name);

        const config = {
            headers: {
                "content-type": "multipart/form-data",
                "content-disposition": "attachment; filename=" + this.state.file.name
            }
        };
        return axios.patch(url, formData, config);
    };

    deleteFile = (e, cpID) => {
        e.preventDefault();

        const url = `/v1/competenceprofiles/${cpID}/`;
        return axios
            .patch(url, {
                illustration: null
            })
            .then((response) => {
                this.setState({
                    illustration: null
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    updateCompetenceprofile = () => {
        let postData = {
            name: this.state.name,
            course_name: this.state.course_name,
            description: this.state.description,
            code: this.state.code,
            type: this.state.type,
            language: this.state.language,
            trainers: this.state.trainers,
            employer: this.state.employer,
            is_standard: this.state.is_standard,
            is_active: this.state.is_active,
            min_date: this.state.min_date ? moment(this.state.min_date).format("YYYY-MM-DD") : null,
            max_date: this.state.max_date ? moment(this.state.max_date).format("YYYY-MM-DD") : null,
            repetition: this.state.repetition,
            eol_item_id: this.state.eolItemUUID,
            certificate_template: this.state.certificate_template,
            certificate_type: this.state.certificate_type,
            certification_name: this.state.certification_name,
            certification_description: this.state.certification_description,
            allow_employer_specific: this.state.allow_employer_specific,
            max_students_per_instructor: this.state.max_students_per_instructor,
            eol_insurance_id: this.state.eolInsuranceItemUUID,
            eol_elearning_full_id: this.state.eolFullItemUUID,
            eol_elearning_partial_id: this.state.eolPartialItemUUID,
            eol_course_cancellation_item_id: this.state.eolCancelItemUUID,
            eol_course_cancellation_knowledge_exam_item_id: this.state.eolCancelKnowledgeExamItemUUID
        };

        if (this.state.editMode) {
            // In case of edit item we PATCH the data
            axios
                .patch("/v1/competenceprofiles/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.updateCompetenceprofileEndterms(this.props.params.itemID);
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response?.data
                    });
                });
        } else {
            // In case of new item we POST the data
            axios
                .post("/v1/competenceprofiles/", postData)
                .then((response) => {
                    this.setState({
                        followUrl: "/competenceprofiles/edit/" + response.data.uuid + "/competences"
                    });
                    this.updateCompetenceprofileEndterms(response.data.uuid);
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                });
        }
    };

    updateCompetenceprofileEndterms = (parentid) => {
        let postData = this.state.end_terms.map((et) => {
            return {
                uuid: et
            };
        });

        if (this.state.content_editable !== false) {
            axios
                .put("/v1/competenceprofiles/" + parentid + "/end_terms/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De algemene informatie en eindtermen onder competentieprofiel '${this.state.name}' zijn succesvol opgeslagen`,
                        link: `/competenceprofiles/edit/${parentid}`
                    });

                    if (this.state.file !== null) {
                        this.fileUpload(parentid).then((response) => {
                            this.props.router.push(this.state.followUrl);
                        });
                    } else {
                        this.props.router.push(this.state.followUrl);
                    }
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                });
        } else {
            this.props.router.push(this.state.followUrl);
        }
    };

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            dirtyForm: true
        });
    };

    loadOptions = (url) => {
        return axios
            .get(url)
            .then((response) => {
                return {
                    options: response.data
                        .map((item) => {
                            return {
                                value: item.uuid,
                                label: item.name
                            };
                        })
                        .sort((a, b) => {
                            if (a.label < b.label) {
                                return -1;
                            }
                            return 1;
                        })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    loadTypeOptions = (url) => {
        return axios
            .get(url)
            .then((response) => {
                return {
                    options: response.data
                        .map((item) => {
                            return {
                                value: item.slug,
                                label: item.name
                            };
                        })
                        .sort((a, b) => {
                            if (a.label < b.label) {
                                return -1;
                            }
                            return 1;
                        })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    loadOptionsDebounced = debounce(this.loadOptions, 500);
    loadTypeOptionsDebounced = debounce(this.loadTypeOptions, 500);
    loadOptionsEndtermsDebounced = debounce(this.loadOptions, 500);
    loadOptionsEmployersDebounced = debounce(this.loadOptions, 500);

    loadOptionsEolItems = (url = "") => {
        return axios
            .get(url)
            .then((response) => {
                return {
                    options: response.data
                        .map((item) => {
                            return {
                                value: item.ID,
                                label: `${item.Code} -  ${item.Description}`
                            };
                        })
                        .sort((a, b) => {
                            if (a.label < b.label) {
                                return -1;
                            }
                            return 1;
                        })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    loadOptionsEolItemsDebounced = debounce(this.loadOptionsEolItems, 500);

    loadDeepOptions = (url = "") => {
        return axios
            .get(url)
            .then((response) => {
                return {
                    options: response.data.map((item) => {
                        return {
                            value: item.uuid,
                            label: item.company.name
                        };
                    })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    handleOptionsChange = (val, stateName) => {
        if (stateName === "eolGroupUUID") {
            this.setState({
                eolItemUUID: null
            });
        }
        if (stateName === "eolInsuranceGroupUUID") {
            this.setState({
                eolInsuranceItemUUID: null
            });
        }
        if (stateName === "type") {
            this.setState({
                type: val?.slug
            });
        }

        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return option.value;
                }),
                dirtyForm: true
            });
        } else if (val == null) {
            this.setState({
                [stateName]: val,
                dirtyForm: true
            });
        } else {
            this.setState({
                [stateName]: val.value,
                dirtyForm: true
            });
        }
    };

    componentDidMount() {
        if (this.state.editMode) {
            // Get the default data of this competence profile
            axios
                .get("/v1/competenceprofiles/" + this.props.params.itemID + "/")
                .then((response) => {
                    this.setState({
                        name: response.data.name,
                        course_name: response.data.course_name,
                        code: response.data.code,
                        type: response.data.type,
                        language: response.data.language,
                        repetition: response.data.repetition ? 1 : 0,
                        content_editable: response.data.content_editable,
                        description: response.data.description,
                        trainers: response.data.trainers,
                        employer: response.data.employer,
                        illustration: response.data.illustration,
                        certificate_template: response.data.certificate_template?.id,
                        certificate_type: response.data.certificate_type?.id,
                        certification_name: response.data.certification_name,
                        certification_description: response.data.certification_description,
                        allow_employer_specific: response.data.allow_employer_specific ? 1 : 0,
                        min_date: response.data.min_date,
                        max_date: response.data.max_date,
                        max_students_per_instructor: response.data.max_students_per_instructor,
                        eolItemUUID: response.data.eol_item_id,
                        eolItemDisplay: response.data.eol_item_display,
                        eolInsuranceItemUUID: response.data.eol_insurance_id,
                        eolInsuranceItemDisplay: response.data.eol_insurance_display,
                        eolFullItemUUID: response.data.eol_elearning_full_id,
                        eolFullItemDisplay: response.data.eol_elearning_full_display,
                        eolPartialItemUUID: response.data.eol_elearning_partial_id,
                        eolPartialItemDisplay: response.data.eol_elearning_partial_display,
                        eolCancelItemUUID: response.data.eol_course_cancellation_item_id,
                        eolCancelItemDisplay: response.data.eol_course_cancellation_item_display,
                        eolCancelKnowledgeExamItemUUID: response.data.eol_course_cancellation_knowledge_exam_item_id,
                        eolCancelKnowledgeExamItemDisplay: response.data.eol_course_cancellation_knowledge_exam_item_display,
                        is_standard: response.data.is_standard ? 1 : 0,
                        is_active: response.data.is_active ? 1 : 0
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

            axios.get(`/v1/competenceprofiles/${this.props.params.itemID}/tree/?nested=true`).then((response) => {
                this.setState({ tree: response.data });
            });

            // todo: Think of a way to manage the tree structure of competence profiles:
            // todo: probably in another view as this gets cramped.
            // axios.get("/v1/competenceprofiletree/?nested=true").then((response) => {
            //     console.info("ALL NODES", response.data);
            // });

            // - fetch /v1/comptenceprofiletree/ (optionally with ?nested=true)
            // - create nodes by POSTing:
            // {
            //     "competence_profile": "<uuid>",
            //     "position": "child",
            //     "node": "<uuid of the parent tree node>"
            // }
            // or:
            // {
            //     "competence_profile": "<uuid>",
            //     "position": "sibling",
            //     "node": "<uuid of the sibling tree node>"
            // }

            // Get the currently coupled end_terms as well
            axios
                .get("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/")
                .then((response) => {
                    this.setState({
                        end_terms: response.data.map((endterm) => {
                            return endterm.uuid;
                        })
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        // Get the certificate templates and types.
        axios
            .get("/v1/certificate-templates/")
            .then((response) => {
                this.setState({
                    certificate_templates: response.data.results
                });
            })
            .catch((error) => {
                console.log(error);
            });
        axios
            .get("/v1/certificate-types/")
            .then((response) => {
                this.setState({
                    certificate_types: response.data.results
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let eolRelated = (
            <div>
                {this.state.eolItemDisplay ? <p>{this.state.eolItemDisplay}</p> : ""}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolRelated: true, eolItemUUID: null });
                    }}
                >
                    {this.state.eolItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );
        let eolItems = "";

        if (this.state.showEolRelated) {
            if (this.state.eolGroupUUID !== null) {
                eolItems = (
                    <div key={"groupUUID" + this.state.eolGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolGroupUUID}
                            value={this.state.eolItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolItems}
                </div>
            );
        }

        let eolInsuranceRelated = (
            <div>
                {this.state.eolInsuranceItemDisplay ? <p>{this.state.eolInsuranceItemDisplay}</p> : <p>(indien van toepassing)</p>}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolInsuranceRelated: true, eolInsuranceItemUUID: null });
                    }}
                >
                    {this.state.eolInsuranceItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );
        let eolInsuranceItems = "";
        if (this.state.showEolInsuranceRelated) {
            if (this.state.eolInsuranceGroupUUID !== null) {
                eolInsuranceItems = (
                    <div key={"groupUUID" + this.state.eolInsuranceGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolInsuranceGroupUUID}
                            value={this.state.eolInsuranceItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolInsuranceGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolInsuranceItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolInsuranceRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolInsuranceGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolInsuranceGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolInsuranceGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolInsuranceItems}
                </div>
            );
        }

        // Build up the EOL related items
        let eolFullRelated = (
            <div>
                {this.state.eolFullItemDisplay ? <p>{this.state.eolFullItemDisplay}</p> : ""}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolFull: true, eolFullItemUUID: null });
                    }}
                >
                    {this.state.eolFullItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );

        let eolFullItems = "";
        if (this.state.showEolFull) {
            if (this.state.eolFullGroupUUID !== null) {
                eolFullItems = (
                    <div key={"groupUUID" + this.state.eolFullGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolFullItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolFullItemUUID}
                            value={this.state.eolFullItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolFullGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolFullItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolFullRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolFullGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolFullGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolFullItems}
                </div>
            );
        }

        let eolPartialRelated = (
            <div>
                {this.state.eolPartialItemDisplay ? <p>{this.state.eolPartialItemDisplay}</p> : ""}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolPartial: true, eolPartialItemUUID: null });
                    }}
                >
                    {this.state.eolPartialItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );
        let eolPartialItems = "";
        if (this.state.showEolPartial) {
            if (this.state.eolPartialGroupUUID !== null) {
                eolPartialItems = (
                    <div key={"groupUUID" + this.state.eolPartialGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolPartialItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolPartialItemUUID}
                            value={this.state.eolPartialItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolPartialGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolPartialItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolPartialRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolPartialGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolPartialGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolPartialItems}
                </div>
            );
        }

        let eolCancelRelated = (
            <div>
                {this.state.eolCancelItemDisplay ? <p>{this.state.eolCancelItemDisplay}</p> : ""}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolCancel: true, eolCancelItemUUID: null });
                    }}
                >
                    {this.state.eolPartialItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );
        let eolCancelItems = "";
        if (this.state.showEolCancel) {
            if (this.state.eolCancelGroupUUID !== null) {
                eolCancelItems = (
                    <div key={"groupUUID" + this.state.eolPartialGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolPartialItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolCancelItemUUID}
                            value={this.state.eolCancelItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolCancelGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolCancelItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolCancelRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolCancelGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolCancelGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolCancelItems}
                </div>
            );
        }

        let eolCancelKnowledgeExamRelated = (
            <div>
                {this.state.eolCancelKnowledgeExamItemDisplay ? <p>{this.state.eolCancelKnowledgeExamItemDisplay}</p> : ""}
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        this.setState({ showEolCancelKnowledgeExam: true, eolCancelKnowledgeExamItemUUID: null });
                    }}
                >
                    {this.state.eolPartialItemUUID !== null ? "Selecteer ander Exact Online product" : "Selecteer een Exact Online product"}
                </button>
            </div>
        );
        let eolCancelKnowledgeExamItems = "";
        if (this.state.showEolCancelKnowledgeExam) {
            if (this.state.eolCancelKnowledgeExamGroupUUID !== null) {
                eolCancelKnowledgeExamItems = (
                    <div key={"groupUUID" + this.state.eolCancelKnowledgeExamGroupUUID}>
                        <br />
                        <Select.Async
                            {...window.selectDefaults}
                            name="eolCancelKnowledgeExamItemUUID"
                            placeholder="Selecteer een Exact Online product"
                            resetGroupValue={this.state.eolCancelKnowledgeExamItemUUID}
                            value={this.state.eolCancelKnowledgeExamItemUUID}
                            loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/items/?group=" + this.state.eolCancelKnowledgeExamGroupUUID)}
                            onChange={(val) => this.handleOptionsChange(val, "eolCancelKnowledgeExamItemUUID")}
                            closeOnSelect={true}
                        />
                    </div>
                );
            }

            eolCancelKnowledgeExamRelated = (
                <div>
                    <Select.Async
                        {...window.selectDefaults}
                        name="eolGroupUUID"
                        placeholder="Selecteer een productgroep"
                        value={this.state.eolCancelKnowledgeExamGroupUUID}
                        loadOptions={() => this.loadOptionsEolItemsDebounced("/v1/crm/itemgroups/")}
                        onChange={(val) => this.handleOptionsChange(val, "eolCancelKnowledgeExamGroupUUID")}
                        closeOnSelect={true}
                    />
                    {eolCancelKnowledgeExamItems}
                </div>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>{this.state.editMode ? <strong>{this.state.name}</strong> : "Nieuw competentieprofiel toevoegen"}</h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={this.state.dirtyForm}
                        activeChapter={1}
                        {...this.props}
                    />
                </div>

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Titel *</label>
                                <input
                                    type="text"
                                    name="name"
                                    ref="name"
                                    onChange={this.updateElementState}
                                    className="form-control form-control-md"
                                    required={true}
                                    value={this.state.name}
                                    autoFocus={true}
                                />
                                <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Titel voor opleider</label>
                                <input
                                    type="text"
                                    name="course_name"
                                    ref="course_name"
                                    onChange={this.updateElementState}
                                    className="form-control form-control-md"
                                    required={false}
                                    value={this.state.course_name}
                                />
                                <FormErrorHandler fieldName="course_name" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>Code</label>
                                <input
                                    type="text"
                                    name="code"
                                    ref="code"
                                    onChange={this.updateElementState}
                                    className="form-control form-control-md"
                                    required={false}
                                    value={this.state.code}
                                />
                                <FormErrorHandler fieldName="code" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Omschrijving</label>
                                <textarea
                                    name="description"
                                    ref="description"
                                    rows="4"
                                    onChange={this.updateElementState}
                                    className="form-control"
                                    value={this.state.description}
                                />
                            </div>

                            <div className="form-group">
                                <label>Taal</label>
                                <select
                                    className="form-control form-control-md"
                                    name="language"
                                    ref="language"
                                    onChange={this.updateElementState}
                                    value={this.state.language}
                                >
                                    <option value="nl">Nederlands</option>
                                    <option value="en">Engels</option>
                                </select>
                                <FormErrorHandler fieldName="language" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Type</label>
                                <Select.Async
                                    {...window.selectDefaults}
                                    name="type"
                                    value={this.state.type}
                                    loadOptions={() => this.loadTypeOptionsDebounced("/v1/competenceprofiletypes/?fields=slug,name&pagination=false")}
                                    onChange={(val) => this.handleOptionsChange(val, "type")}
                                    closeOnSelect={true}
                                />
                                <FormErrorHandler fieldName="type" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Opleider</label>
                                <Select.Async
                                    {...window.selectDefaults}
                                    name="trainers"
                                    value={this.state.trainers}
                                    loadOptions={() => this.loadOptionsDebounced("/v1/trainers/?fields=uuid,name&pagination=false")}
                                    onChange={(val) => this.handleOptionsChange(val, "trainers")}
                                    closeOnSelect={true}
                                    multi={true}
                                />
                                <FormErrorHandler fieldName="trainers" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Bedrijf</label>
                                <Select.Async
                                    {...window.selectDefaults}
                                    name="employer"
                                    value={this.state.employer}
                                    loadOptions={() => this.loadOptionsEmployersDebounced("/v1/employers/?fields=uuid,name&pagination=false")}
                                    onChange={(val) => this.handleOptionsChange(val, "employer")}
                                    closeOnSelect={true}
                                />
                                <FormErrorHandler fieldName="trainer" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Certificaat template</label>
                                <br />
                                <select
                                    className="form-control form-control-md"
                                    name="certificate_template"
                                    ref="certificate_template"
                                    onChange={this.updateElementState}
                                    value={this.state.certificate_template}
                                >
                                    {this.state.certificate_templates.map((item) => (
                                        <option value={item.id} key={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <FormErrorHandler fieldName="certificate_template" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>Certificaat type</label>
                                <br />
                                <select
                                    className="form-control form-control-md"
                                    name="certificate_type"
                                    ref="certificate_type"
                                    onChange={this.updateElementState}
                                    value={this.state.certificate_type}
                                >
                                    {this.state.certificate_types.map((item) => (
                                        <option value={item.id} key={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <FormErrorHandler fieldName="certificate_type" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Certificaat naam</label>
                                <input
                                    type="text"
                                    name="certification_name"
                                    ref="certification_name"
                                    onChange={this.updateElementState}
                                    className="form-control form-control-md"
                                    required={false}
                                    value={this.state.certification_name}
                                />
                                <FormErrorHandler fieldName="certification_name" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Certificaat beschrijving</label>
                                <textarea
                                    name="certification_description"
                                    ref="certification_description"
                                    onChange={this.updateElementState}
                                    className="form-control form-control-md"
                                    required={false}
                                    value={this.state.certification_description}
                                />
                                <small className="form-text text-muted">
                                    Een zin die op het certificaat wordt geplaatst. Inclusief "Heeft voldaan aan de eisen van het certificeringsreglement &hellip;"
                                </small>
                                <FormErrorHandler fieldName="certification_description" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Bedrijfsspecifiek toegestaan</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="allow_employer_specific"
                                            ref="allow_employer_specific"
                                            onChange={this.updateElementState}
                                            value={this.state.allow_employer_specific}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="allow_employer_specific" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Herhaling</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="repetition"
                                            ref="repetition"
                                            onChange={this.updateElementState}
                                            value={this.state.repetition}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="repetition" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Standaard</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="is_standard"
                                            ref="is_standard"
                                            onChange={this.updateElementState}
                                            value={this.state.is_standard}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="is_standard" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Actief</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="is_active"
                                            ref="is_active"
                                            onChange={this.updateElementState}
                                            value={this.state.is_active}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Startdatum</label>
                                        <DatePicker
                                            name="min_date"
                                            onChange={(date) => {
                                                this.setState({ min_date: date });
                                            }}
                                            onChangeRaw={(event) => {
                                                let value = event.target.value.split("-").join("");
                                                let newDate = value.substring(0, 2);
                                                if (value.length >= 3) {
                                                    newDate += "-" + value.substring(2, 4);
                                                }
                                                if (value.length >= 5) {
                                                    let checkYear = value.substring(4, 8);
                                                    if (checkYear.length === 2 && checkYear !== "19" && checkYear !== "20") {
                                                        newDate += "-20" + value.substring(4, 8);
                                                    } else {
                                                        newDate += "-" + value.substring(4, 8);
                                                    }
                                                }
                                                event.target.value = newDate;
                                            }}
                                            className="form-control"
                                            placeholderText="-- -- ----"
                                            selected={this.state?.min_date ? moment(this.state.min_date) : null}
                                            dropdownMode="select"
                                            autoComplete="off"
                                        />
                                        <FormErrorHandler fieldName="min_date" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Einddatum</label>
                                        <DatePicker
                                            name="max_date"
                                            onChange={(date) => {
                                                this.setState({ max_date: date });
                                            }}
                                            onChangeRaw={(event) => {
                                                let value = event.target.value.split("-").join("");
                                                let newDate = value.substring(0, 2);
                                                if (value.length >= 3) {
                                                    newDate += "-" + value.substring(2, 4);
                                                }
                                                if (value.length >= 5) {
                                                    let checkYear = value.substring(4, 8);
                                                    if (checkYear.length === 2 && checkYear !== "19" && checkYear !== "20") {
                                                        newDate += "-20" + value.substring(4, 8);
                                                    } else {
                                                        newDate += "-" + value.substring(4, 8);
                                                    }
                                                }
                                                event.target.value = newDate;
                                            }}
                                            className="form-control"
                                            placeholderText="-- -- ----"
                                            selected={this.state?.max_date ? moment(this.state.max_date) : null}
                                            minDate={this.state?.min_date ? moment(this.state.min_date) : null}
                                            dropdownMode="select"
                                            autoComplete="off"
                                        />
                                        <FormErrorHandler fieldName="max_date" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Maximaal aantal cursisten per instructeur</label>
                                        <input
                                            type="number"
                                            name="max_students_per_instructor"
                                            ref="max_students_per_instructor"
                                            onChange={this.updateElementState}
                                            className="form-control form-control-md"
                                            required={true}
                                            value={this.state.max_students_per_instructor}
                                        />
                                        <FormErrorHandler fieldName="max_students_per_instructor" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Afbeelding (SVG)</label>
                                        <br />
                                        {this.state.illustration !== null ? (
                                            <div className="image-preview">
                                                <img src={this.state.illustration} alt="afbeelding" />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <input type="file" name="file" className="form-control-file" onChange={this.handleFileChange} />
                                        <br />
                                        {this.state.illustration !== null && this.props.params.itemID ? (
                                            <button
                                                className="btn btn-secondary"
                                                onClick={(e) => {
                                                    this.deleteFile(e, this.props.params.itemID);
                                                }}
                                            >
                                                Verwijder de huidige afbeelding
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                        <FormErrorHandler fieldName="illustration" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label>Exact Online product voor deze cursus</label>
                                {eolRelated}
                                <FormErrorHandler fieldName="eol_item_id" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Exact Online verzekering</label>
                                {eolInsuranceRelated}
                                <FormErrorHandler fieldName="eol_insurance_id" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Exact Online product voor het afronden van een Elearning toetsmoment</label>
                                {eolFullRelated}
                                <FormErrorHandler fieldName="eol_elearning_full_id" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Exact Online product voor een vrijstelling van een Elearning toetsmoment</label>
                                {eolPartialRelated}
                                <FormErrorHandler fieldName="eol_elearning_partial_id" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Exact Online product als een cursus geannuleerd wordt</label>
                                {eolCancelRelated}
                                <FormErrorHandler fieldName="eol_course_cancellation_item_id" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <label>Exact Online product als een cursus geannuleerd wordt nadat een kennisexamen is gedownload</label>
                                {eolCancelKnowledgeExamRelated}
                                <FormErrorHandler fieldName="eol_course_cancellation_knowledge_exam_item_id" errorObject={this.state.errorMessage} />
                            </div>

                            <h3>Boomstructuur</h3>
                            <div className="form-group">{this.state.tree && <ProfileNodeTree nodes={this.state.tree} current={this.props.params.itemID} />}</div>

                            {/*<div className="form-group">*/}
                            {/*    <Select*/}
                            {/*        {...window.selectDefaults}*/}
                            {/*        name="parent"*/}
                            {/*        value={"current parent"}*/}
                            {/*        options={this.state.tree ? Object.values(this.state.tree).reduce((options, item) => {*/}
                            {/*            const option = { value: item.uuid, label: ("-".repeat(item.depth)) + item.name };*/}
                            {/*            if (!options[item.uuid]) {*/}
                            {/*                options[item.uuid] = option;*/}
                            {/*            }*/}
                            {/*        }, {}).values() : []}*/}
                            {/*        onChange={(selection) => {*/}
                            {/*            this.setState({ tree: selection });*/}
                            {/*        }} />*/}
                            {/*</div>*/}
                        </div>
                    </div>

                    <CompetenceProfileFiles id={this.props.params.itemID} />

                    {this.state.content_editable === false ? (
                        <div className="alert alert-danger">
                            Je kunt de onderstaande gegevens van dit competentieprofiel niet veranderen of bijwerken omdat er al toetsmomenten op basis van dit
                            competentieprofiel zijn aangemaakt.
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>Eindtermen</label>
                                <Select.Async
                                    {...window.selectDefaults}
                                    name="end_terms"
                                    value={this.state.end_terms}
                                    loadOptions={() => this.loadOptionsEndtermsDebounced("/v1/end_terms/?fields=uuid,name,collection&pagination=false")}
                                    onChange={(val) => this.handleOptionsChange(val, "end_terms")}
                                    required={false}
                                    multi={true}
                                    className="full-width-labels"
                                    readOnly={this.state.content_editable === false}
                                    disabled={this.state.content_editable === false}
                                />
                                <FormErrorHandler fieldName="end_terms" errorObject={this.state.errorMessage} />
                            </div>
                        </div>
                    </div>

                    <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                    <div className="form-group text-center">
                        <button className="btn btn-light" type="button" onClick={this.handleSubmitPrevious}>
                            Opslaan en terug naar het overzicht
                        </button>
                        <button className="btn btn-primary" type="submit">
                            Opslaan en naar competenties
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

function CompetenceProfileFiles({ id }) {
    const initial = {
        name: "",
        file: null,
        description: ""
        // visible: true,
    };
    const [files, setFiles] = React.useState([]);
    const [data, setData] = React.useState(initial);
    const [errors, setErrors] = React.useState({});
    const fileInput = React.useRef(null);

    const listUrl = `/v1/competenceprofiles/${id}/files/`;
    const required = ["name", "file"];
    const valid = required.every((field) => !!data[field]);

    if (!id) {
        return <div className="alert alert-info">Nadat het profiel is opgeslagen kunnen bestanden worden toegevoegd.</div>;
    }

    const fetchFiles = () => {
        axios
            .get(listUrl)
            .then((response) => setFiles(response.data.results))
            .catch((error) => console.log(error));
    };

    const setField = (field, value) => setData({ ...data, [field]: value });

    const handleSave = (event) => {
        event.preventDefault();

        const newErrors = required.reduce((acc, field) => {
            if (!data[field]) {
                acc[field] = "Dit veld is verplicht";
            }
            return acc;
        }, {});
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        return axios.post(listUrl, formData).then(() => {
            fetchFiles();
            setData(initial);
            setErrors({});
            fileInput.current.value = null;
        });
    };

    const deleteFile = (uuid) => {
        axios.delete(`${listUrl}${uuid}/`).then(fetchFiles);
    };
    const setFileVisible = (uuid, visible) => {
        axios.patch(`${listUrl}${uuid}/`, { visible }).then(fetchFiles);
    };

    React.useEffect(() => fetchFiles(), []);

    return (
        <div className="row">
            <div className="col-12">
                <h3>Bestanden</h3>
            </div>
            <div className="col-6">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th width="120">Acties</th>
                        </tr>
                    </thead>
                    <tbody>
                        {files.map((file) => (
                            <tr key={file.uuid}>
                                <td>
                                    {file.name}
                                    {file.description && <div className="text-muted">{file.description}</div>}
                                </td>
                                <td>
                                    <IconToolTip id={`delete-file-${file.uuid}`}>Verwijder dit bestand</IconToolTip>
                                    <button
                                        type="button"
                                        className="fa fa-trash overview-redux__button"
                                        data-tip={true}
                                        data-for={`delete-file-${file.uuid}`}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            deleteFile(file.uuid);
                                        }}
                                    >
                                        Verwijder
                                    </button>
                                    <IconToolTip id={`toggle-file-${file.uuid}`}>
                                        {file.visible ? "Maak dit bestand onzichtbaar" : "Maak dit bestand zichtbaar"}
                                    </IconToolTip>
                                    <button
                                        type="button"
                                        className={classNames("fa overview-redux__button", {
                                            "fa-eye": file.visible,
                                            "fa-eye-slash": !file.visible
                                        })}
                                        data-tip={true}
                                        data-for={`toggle-file-${file.uuid}`}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            setFileVisible(file.uuid, !file.visible);
                                        }}
                                    >
                                        {file.visible ? "Zichtbaar" : "Onzichtbaar"}
                                    </button>
                                    <IconToolTip id={`download-${file.uuid}`}>Download</IconToolTip>
                                    <button
                                        type="button"
                                        className="fa overview-redux__button fa-download"
                                        data-tip={true}
                                        data-for={`download-${file.uuid}`}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            downloadFile(file.url);
                                        }}
                                    >
                                        Download
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="2">
                                <i className="fa fa-download" />
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        downloadFile(`${listUrl}all/`);
                                    }}
                                >
                                    Download alle bestanden (zip)
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="col-6">
                <div className="form-group">
                    <label>Voeg bestand toe</label>
                    <input type="file" name="file" className="form-control-file" ref={fileInput} onChange={(e) => setField("file", e.target.files[0])} />
                    <FormErrorHandler fieldName="file" errorObject={errors} />
                    <label>Naam</label>
                    <input type="text" name="name" className="form-control" value={data.name} onChange={(e) => setField("name", e.target.value)} />
                    <FormErrorHandler fieldName="name" errorObject={errors} />
                    <label>Beschrijving</label>
                    <textarea
                        name="description"
                        className="form-control"
                        placeholder="Beschrijving"
                        onChange={(e) => setField("description", e.target.value)}
                        value={data.description}
                    />
                    <FormErrorHandler fieldName="description" errorObject={errors} />
                    <p className="mt-3">
                        <button type="button" className="btn btn-secondary" disabled={!valid} onClick={handleSave}>
                            Voeg bestand toe
                        </button>
                        <span className="text-muted">Bestanden worden meteen opgeslagen</span>
                    </p>
                </div>
            </div>
        </div>
    );
}

function IconToolTip(props) {
    return <ReactTooltip effect="solid" place={"top"} delayShow={250} delayHide={125} {...props} />;
}

/**
 * Renders the nested tree data from the server into a nested ul/li structure.
 * @param {Array} nodes
 * @param {Boolean} isRoot
 * @param {String} current UUID of the "current" or "active" competence profile.
 * @returns {React.ReactNode}
 */
function ProfileNodeTree({ nodes, isRoot = true, current = null }) {
    const items = nodes.map((node) => {
        return (
            <li
                key={node.uuid}
                className={classNames("tree__item", {
                    "tree__item--active": current === node.competence_profile.uuid
                })}
            >
                <span className="tree__label">{node.competence_profile.name}</span>
                {node.children && node.children.length > 0 && <ProfileNodeTree nodes={node.children} current={current} isRoot={false} />}
            </li>
        );
    });
    return <ul className={classNames("tree", { "tree--root": isRoot })}>{items}</ul>;
}
